import React from "react";

import "./cardRichText.scss";

interface CardRichTextInter {
  items: any;
}

const CardRichText = (props: CardRichTextInter) => {
  const { items } = props;

  return (
    <div className="a-card-richtext">
      {items.map((elem, idx) => {
        return (
          <div className="a-card-richtext__container" key={idx}>
            <p className="icon-circle"></p>
            <p className="a-card-richtext__container-text">
              {elem.content[0].value}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default CardRichText;
